define('admin/teams/teamUsers',['jquery', 'plugins/http', 'knockout', 'durandal/app'], function($, http, ko, app) {
    var viewmodel = function() {
        var self = this;

        self.page = 1;
        self.canLoadMore = ko.observable(false);
        self.loading = ko.observable(false);
        self.totalUsers = ko.observable(0);
        self.teamId = null;
        self.teamUsers = ko.observableArray([]);
        self.teamHasUsers = ko.computed(function () {
            return self.teamUsers().length > 0;
        });
        self.teamUserSearchTerm = ko.observable();
        self.renderedUsers = ko.computed(function() {
            var data = self.teamUsers();
            var times = Math.ceil(data.length / 3);
            var result = [];
          
            for (var i = 0; i < times; i ++) {
                result.push(data.slice(i * 3, i * 3 + 3));
            }

            return result;
        });

        self.activate = function (teamId) {
            self.teamId = teamId;

            self.refresh();
        };

        self.refresh = function () {
            self.page = 1;

            self.teamUsers.removeAll();

            self.loadNextPageOfUsers();
        };

        self.loadNextPageOfUsers = function() {
            self.getTeamUsers(self.teamId)
                .then(self.processTeamUsers)
                .fail(app.showError);
        };

        self.processTeamUsers = function (response) {
            var users = response.data.users;

            self.loading(false);
            self.canLoadMore(response.data.moreToCome);
            self.totalUsers(response.data.total);

            if (response.data.moreToCome) {
                self.page++;
            }

            ko.utils.arrayPushAll(self.teamUsers, users);
        };

        // ui
        self.clearUserSearch = function () {
            self.teamUserSearchTerm('');

            self.refresh();
        };

        self.userSearch = function () {
            self.teamUsers.removeAll();
            
            self.findUsers(self.teamUserSearchTerm())
                .then(self.processTeamUsers)
                .fail(app.showError);
        };

        self.removeUserFromTeamCommand = function(user) {
            var userId = user.id;
            
            self.removeUser(userId)
                .then(self.refresh)
                .fail(app.showError);
        };
        
        self.addUserToTeamCommand = function (user) {
            var userId = user.id;

            self.addUser(userId)
                .then(self.refresh)
                .fail(app.showError);
        };
        
        // api
        self.getTeamUsers = function (teamId) {
            self.loading(true);

            var url = '/api/admin/teams/users',
                data = {
                    teamId: teamId,
                    page: self.page
                };

            return http.get(url, data);
        };

        self.findUsers = function(searchTerm) {
            var url = '/api/admin/teams/users/search',
                data = {
                    searchTerm: searchTerm,
                    teamId: self.teamId
                };

            return http.post(url, data);
        };

        self.addUser = function (userId) {
            var url = '/api/admin/teams/adduser',
                data = {
                    userId: userId,
                    teamId: self.teamId
                };

            return http.post(url, data);
        };
        
        self.removeUser = function (userId) {
            var url = '/api/admin/teams/removeuser',
                data = {
                    userId: userId,
                    teamId: self.teamId
                };

            return http.post(url, data);
        };
    };

    return viewmodel;
});

